const FileSaver = require('file-saver')
const XLSX = require('xlsx')


const ExcelExport = (data, fileName) => {

    let gz = 15
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(data);
    var wscols = [
        { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz },
        { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz },
        { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz }, { wch: gz },
    ];
    ws['!cols'] = wscols;
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const datas = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(datas, fileName + fileExtension);
    return
}

export default ExcelExport
